import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";

var NumericSeparatorTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(NumericSeparatorTransformer, _Transformer);

  var _super = _createSuper(NumericSeparatorTransformer);

  function NumericSeparatorTransformer(tokens) {
    var _this;

    _classCallCheck(this, NumericSeparatorTransformer);

    _this = _super.call(this);
    _this.tokens = tokens;
    ;
    return _this;
  }

  _createClass(NumericSeparatorTransformer, [{
    key: "process",
    value: function process() {
      if (this.tokens.matches1(tt.num)) {
        var code = this.tokens.currentTokenCode();

        if (code.includes("_")) {
          this.tokens.replaceToken(code.replace(/_/g, ""));
          return true;
        }
      }

      return false;
    }
  }]);

  return NumericSeparatorTransformer;
}(Transformer);

export { NumericSeparatorTransformer as default };